import { CouponBase } from "../coupon-base";
export class AmountOffCouponBase extends CouponBase {
    _discountAmount;
    constructor(appType, sourceData, deps, baseData, identity) {
        super(appType, sourceData, deps, baseData, identity);
        this._discountAmount = baseData.discount;
    }
    meetsPreConditions(cart) {
        return super.meetsPreConditions(cart);
    }
    calculateDiscount(cart) {
        const discountItems = this.getDiscountItems(cart);
        const totalAmounts = this._getTotalCouponItemsPrices(discountItems);
        const discountAmount = this.computeDiscountAmount(totalAmounts, cart);
        const distributor = this._coupon.isBeforeTax ? this.getBeforeTaxDistributor() : this.getAfterTaxDistributor();
        distributor.distribute({
            cart,
            discountItems,
            totalDiscountedItemsPrice: totalAmounts.orderItemPrice,
            computedDiscountToAllocate: discountAmount,
        });
        return [discountAmount, discountItems];
    }
}
//# sourceMappingURL=amount-off-base.js.map